import React, { createContext, useState, useEffect } from "react";
import { getHighRiskPatients } from "../services/getHighRiskPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const HighRiskContext = createContext();

export const HighRiskProvider = ({ children }) => {
  const [highRiskPatients, setHighRiskPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [memberType, setMemberType] = useState(null);

  const { token, isValid, authLoading } = useValidToken();

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getHighRiskPatients(null, locationId, memberType);
        setHighRiskPatients(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, locationId, memberType]);

  return (
    <HighRiskContext.Provider value={{
      highRiskPatients,
      loading,
      error,
      setLocationId,
      setMemberType,
    }}>
      {children}
    </HighRiskContext.Provider>
  );
};
